<template>
  <v-container>
    <div class="d-flex align-center mb-4">
      <v-btn
        icon
        class="mr-1"
        :to="listRoute"
        exact
      >
        <v-icon>{{ icons.mdiArrowLeft }}</v-icon>
      </v-btn>
      <div>
        <h2 class="text-h6 mb-0">
          {{ periodStart }} 〜 {{ periodEnd }}
        </h2>
        <div class="text-caption text--secondary">
          {{ roleLabel(role) }}
        </div>
      </div>
    </div>

    <template v-if="isLoading">
      <v-skeleton-loader type="table" />
    </template>

    <ConfirmationTable
      v-else-if="confirmations.length > 0"
      :confirmations="confirmations"
      :columns="columns"
      :cell-of="cellOf"
      :updating-cell-keys="updatingCellKeys"
      :is-all-confirmed="isAllConfirmed"
      :is-confirming="isConfirming"
      :is-unconfirming="isUnconfirming"
      @update-cell="onUpdateCell"
      @confirm="confirmConfirmations"
      @unconfirm="unconfirmConfirmations"
      @select-user="onSelectUser"
    />

    <v-alert
      v-else
      type="info"
      text
      dense
    >
      確定データがありません。一覧の「新規作成」から作成してください。
    </v-alert>

    <IntermediateValuesDialog
      v-model="intermediateDialog"
      :values="intermediateValues"
      :is-loading="isLoadingIntermediate"
      :user-name="selectedUserName"
    />
  </v-container>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api'
import { mdiArrowLeft } from '@mdi/js'
import ConfirmationTable from './components/ConfirmationTable.vue'
import IntermediateValuesDialog from './components/IntermediateValuesDialog.vue'
import { usePayrollConfirmation } from './composables/usePayrollConfirmation'

export default {
  components: {
    ConfirmationTable,
    IntermediateValuesDialog,
  },
  props: {
    role: {
      type: String,
      required: true,
    },
    periodStart: {
      type: String,
      required: true,
    },
    periodEnd: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const {
      selectedRole,
      dates,
      confirmations,
      isLoading,
      isConfirming,
      isUnconfirming,
      updatingCellKeys,
      intermediateValues,
      isLoadingIntermediate,
      selectedUserName,
      isAllConfirmed,
      columns,
      cellOf,
      roleLabel,
      fetchRoles,
      fetchConfirmations,
      updateCell,
      confirmConfirmations,
      unconfirmConfirmations,
      fetchIntermediateValues,
    } = usePayrollConfirmation()

    const intermediateDialog = ref(false)

    const listRoute = { name: 'payroll-confirmations' }

    const onUpdateCell = ({ conf, cellKey, value }) => {
      updateCell(conf, cellKey, value)
    }

    const onSelectUser = conf => {
      fetchIntermediateValues(conf)
      intermediateDialog.value = true
    }

    onMounted(async () => {
      // ロール表示名の解決に必要
      fetchRoles()
      selectedRole.value = props.role
      dates.value = [props.periodStart, props.periodEnd]
      await fetchConfirmations()
    })

    return {
      confirmations,
      isLoading,
      isConfirming,
      isUnconfirming,
      updatingCellKeys,
      intermediateValues,
      isLoadingIntermediate,
      selectedUserName,
      isAllConfirmed,
      columns,
      cellOf,
      roleLabel,
      intermediateDialog,
      listRoute,
      onUpdateCell,
      confirmConfirmations,
      unconfirmConfirmations,
      onSelectUser,
      icons: {
        mdiArrowLeft,
      },
    }
  },
}
</script>
